import React, {Component} from 'react';
import snapshot from '../style/imgs/snapshot.jpg';
import {Row, Col, Badge} from 'antd';
import {UUID_NULL} from '../constants/defaultValues';

const styles = {
  thumbnail: {
    position: 'relative',
    color: '#fff',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    //boxShadow: '0 3px 3px rgba(0, 0, 0, 0.16), 0 3px 3px rgba(0, 0, 0, 0.22)',
    cursor: 'pointer',
    // zIndex: -1
  },
  title: {
    position: 'absolute',
    top: 4,
    left: 0,
    paddingLeft: 4,
    paddingRight: 4,
    boxSizing: 'border-box',
    width: '100%'
  },
  caption: {
    float: 'left',
    display: 'inline-block'
  },
  shadow: {
    textShadow: '-1px 0 1px #000, 1px 0 1px #000, 0 -1px 1px #000, 0 1px 1px #000'
  },
  online: {
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: '50%',
    marginLeft: 4,
    marginRight: 4,
    //boxShadow: '0 3px 3px rgba(0, 0, 0, 0.16), 0 3px 3px rgba(0, 0, 0, 0.22)'
  },
  italic: {
    fontStyle: 'italic',
    fontSize: 12,
    color: '#FFF',
    textShadow: '-1px 0 1px #000, 1px 0 1px #000, 0 -1px 1px #000, 0 1px 1px #000'
  },
  badgle: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    fontSize: 14,
    width: 24,
    height: 24,
    borderRadius: '50%',
    marginRight: 8
  },
  snapshot: {
    flexShrink: 0,
    width: '100%',
    height: '100%'
  },
  bottom: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    paddingRight: 4,
    paddingBottom: 4,
    boxSizing: 'border-box',
    width: '100%',
    fontSize: 12
  },
  right: {
    float: 'right',
    display: 'inline-block',
    textAlign: 'right'
  }
}

export default class StationSnapshot extends Component {
  constructor(props) {
    super(props)
    this.state = {
      snapshot: this.props.linkSnapShot,
      link: `${this.props.linkSnapShot}`,
      station: this.props.station,
      alarmLevel: this.props.alarmLevel,
      alarmCount: this.props.alarmCount,
      alarmList: this.props.alarmList,
      intervalId: 0
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({alarmLevel: nextProps.alarmLevel, alarmCount: nextProps.alarmCount, alarmList: nextProps.alarmList})
  }

  componentWillMount() {
    const {link} = this.state
    if (link && link.indexOf(UUID_NULL) < 0) {
      let intervalId = setInterval(this._refresh.bind(this), 30000);
      this.setState({intervalId: intervalId});
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  _refresh() {
    const {link} = this.state
    const random = Math.random().toString(24).substring(7);
    const url = (link && link.indexOf("/") > -1)
      ? link.substring(0, link.lastIndexOf("/") + 1)
      : link
    this.setState({
      link: url + random,
      random: random
    });
  }

  render() {
    const {link, station} = this.state
    const {alarmList} = this.props
    let badge = ''
    if (station.AlarmLevel === 0) {
      badge = <Badge status="success"/>
    } else if (station.AlarmLevel === 1) {
      badge = <Badge count={station.AlarmCount} style={{
          backgroundColor: '#F5AD10',
          color: '#FFF'
        }}/>
    } else if (station.AlarmLevel === 2) {
      badge = <Badge count={station.AlarmCount} style={{
          backgroundColor: '#d73435',
          color: '#FFF'
        }}/>
    } else {
      badge = <Badge style="default"/>
    }
    const alarms = ""
    return (<div style={styles.thumbnail}>
      <div style={styles.title}>
        <div style={styles.caption}>
          {badge}
          <span style={styles.italic}>{station.Name}</span>
        </div>
      </div>
      <img src={link.length > 0
          ? link
          : snapshot} style={styles.snapshot}/>
      <div style={styles.bottom}>
        <div style={styles.right}>
          <Row>
            {alarms}
          </Row>
        </div>
      </div>
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/components/StationSnapshot.js